import { ModelBase } from 'store/model-base';

export class CallbackTime extends ModelBase {
    public static storeName: string = 'callbackTime';

    public phoneNumber: string;
    public estimatedWaitTimeMins: number;
}
